import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { FormHandles } from "models/propTypes/genericFormProps";
import { StyleEnums } from "models/enums";
import { SettingsFormViewPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import FormValidity from "../forms/formValidity";
import ViewPanel from "./viewPanel";
import PageFooter from "../pageFooter";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SettingsFormViewPanel: React.FC<SettingsFormViewPanelProps> = (props) => {
  const { title, setNavLayoutSections, allowForReadOnlyUsers, hideSave } = props;
  const formRef = React.useRef<FormHandles>(null);

  const submitForm = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const childElement = React.Children.only(props.children);

  return (
    <FormValidity
      render={(isValid, onValidityChange, isDirty, onDirtyChange) => (
        <>
          <ViewPanel
            title={title ? LocalizationHelperInstance.getFormattedMessage(title) : undefined}
            className={cssExports.settingsFormViewPanel}
            classes={{ content: clsx(cssExports.detailsFormContainer) }}
          >
            {React.cloneElement(childElement, {
              ref: formRef,
              onFormValidationChange: onValidityChange,
              setNavLayoutSections: setNavLayoutSections,
              onFormDirtyChange: onDirtyChange,
            })}
          </ViewPanel>
          {!hideSave && (
            <PageFooter
              actions={
                isDirty
                  ? [
                      {
                        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
                        onClick: submitForm,
                        type: StyleEnums.DisplayType.Success,
                        isDisabled: !isValid,
                        successMessage: props.successMessage ?? TranslationKeys.Settings.SavedSettingsSuccessfully,
                      },
                    ]
                  : []
              }
              allowForReadOnlyUsers={allowForReadOnlyUsers}
              onActionSuccess={props.onSubmitSuccess}
            />
          )}
        </>
      )}
    />
  );
};

export default SettingsFormViewPanel;
